const UiToggle2 = ({ state }) => {



    return (
        <div>
            {state ?
                <i className="bi bi-check-square h5" style={{color: "#650260"}}></i>
                
                :
                <i className="bi bi-square h5" style={{color: "#650260"}}></i>
            }


        </div>


    )
}

export default UiToggle2